module.exports = __webpack_public_path__ + "img/uniqueFeature.99c7ce3b.png";